import { isAuroraDesktop } from './desktopRuntime';

export function supportsDesktopPictureInPicture(video?: HTMLVideoElement | null): boolean {
  if (!isAuroraDesktop() || typeof document === 'undefined') return false;
  if (document.pictureInPictureEnabled === false) return false;
  return !video || typeof video.requestPictureInPicture === 'function';
}

export function isVideoInPictureInPicture(video: HTMLVideoElement | null): boolean {
  if (!video || typeof document === 'undefined') return false;
  return document.pictureInPictureElement === video;
}

export async function togglePictureInPicture(video: HTMLVideoElement | null): Promise<boolean> {
  if (!video || !supportsDesktopPictureInPicture(video)) return false;

  if (document.pictureInPictureElement === video) {
    await document.exitPictureInPicture();
    return false;
  }

  if (document.pictureInPictureElement) {
    await document.exitPictureInPicture();
  }

  await video.requestPictureInPicture();
  return true;
}
